export default "__VITE_ASSET__057aa9df__"